var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostaRica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40.0001C31.0459 40.0001 40.0002 31.0458 40.0002 20.0001C40.0002 8.95436 31.0459 6.10352e-05 20.0002 6.10352e-05C8.95455 6.10352e-05 0.000244141 8.95436 0.000244141 20.0001C0.000244141 31.0458 8.95455 40.0001 20.0002 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.756 13.0435H1.24398C0.440078 15.2102 0 17.5536 0 20C0 22.4464 0.440078 24.7898 1.24398 26.9565H38.7561C39.56 24.7898 40 22.4464 40 20C40 17.5536 39.56 15.2102 38.756 13.0435Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6.10352e-05C13.9382 6.10352e-05 8.50672 2.69725 4.83899 6.95654H35.1609C31.4933 2.69725 26.0618 6.10352e-05 20 6.10352e-05V6.10352e-05Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.161 33.0436H4.83899C8.50672 37.3029 13.9382 40.0001 20 40.0001C26.0618 40.0001 31.4933 37.3029 35.161 33.0436Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostaRica);
export default __webpack_public_path__ + "static/media/costa_rica.fd3a23102e7c2249ba00cca9152b1265.svg";
export { ForwardRef as ReactComponent };